import {Component} from '@angular/core';
import {ResponsiveService} from '../../services/responsive.service';
import {
  UtButtonComponent,
  UtDialogContentDirective,
  UtDialogRef,
} from 'src/app/ui';
import {ProfileFormComponent} from '../edit/profile-form/profile-form.component';

@Component({
  selector: 'app-profile-dialog',
  templateUrl: './profile-dialog.component.html',
  styleUrls: ['./profile-dialog.component.scss'],
  imports: [
    ProfileFormComponent,
    UtButtonComponent,
    UtDialogContentDirective,
  ],
})
export class ProfileDialogComponent {
  constructor(
    public responsive: ResponsiveService,
    private dialogRef: UtDialogRef<void>,
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
